import {facilities} from './facilities';

export const Dictionary = {facilities};
